import React, {useEffect, useState} from 'react'
import {useSelector} from 'react-redux';
import DataTable from 'react-data-table-component';
import {Link, useLocation} from "react-router-dom";
import {get_budget_reappropriate} from "../../helper/Api";
import { AddCommasToAmount } from "../../helper/Utils";
import {AiOutlineEye, AiOutlineVerticalAlignBottom} from 'react-icons/ai';
import { Card, CardContent, Tooltip } from '@mui/material';
import moment from 'moment';
import './BudgetReappropriateList.css';

const getApprovalBadgeClass = (approval) => {
    if (approval === null || approval === undefined || approval === '') {
        return 'bg-warning-20';
    }
    if (String(approval) === '1') {
        return 'bg-success-20';
    }
    if (String(approval) === '0') {
        return 'bg-danger-20';
    }
    return 'bg-warning-20';
};

const getApprovalIconClass = (approval) => {
    if (approval === null || approval === undefined || approval === '') {
        return 'icon-warning_amber text-warning-100';
    }
    if (String(approval) === '1') {
        return 'icon-verified text-success-100';
    }
    if (String(approval) === '0') {
        return 'icon-warning_amber text-danger-100';
    }
    return 'icon-warning_amber text-warning-100';
};

const ApprovalStatusCell = ({ row }) => (
    <div className="budget-reapp-approval-cell">
        <span className={`budget-reapp-approval-badge ${getApprovalBadgeClass(row.l2_approval)}`}>
            L2 <i className={`${getApprovalIconClass(row.l2_approval)} fs-16px`}></i>
        </span>
        <span className={`budget-reapp-approval-badge ${getApprovalBadgeClass(row.l3_approval)}`}>
            L3 <i className={`${getApprovalIconClass(row.l3_approval)} fs-16px`}></i>
        </span>
    </div>
);

export default function BudgetReappropriateList({ filterApplied, fyId, pending = false }) {
    const {authData} = useSelector((state) => state.authData);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    let {state} = useLocation();
    const [data, setData] = useState(state && state.data ? state.data : []);
    

    const formatAmount = (value) => {
        if (value === null || value === undefined || value === '') return '-';
        return AddCommasToAmount(value);
    };

    const customStyles = {
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "14px"
            },
        },
    };

    const handleDownloadOrder = (url) => {
        if (!url) return;
        const link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        link.rel = 'noreferrer';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const columns = [
        {
            name: 'Actions',
            cell: (row) => (
                <div className="budget-reapp-actions">
                    <Tooltip title="Download Reappropriate Order" arrow placement="top">
                        <span className="budget-reapp-action-tooltip-wrap">
                            <button
                                type="button"
                                className="budget-reapp-action-btn budget-reapp-action-btn--download"
                                disabled={!row?.order_url}
                                onClick={() => handleDownloadOrder(row.order_url)}
                            >
                                <AiOutlineVerticalAlignBottom size={16} />
                            </button>
                        </span>
                    </Tooltip>
                    <Tooltip title="View Reappropriation" arrow placement="top">
                        <span className="budget-reapp-action-tooltip-wrap">
                            <Link
                                to={`/add-budget-reappropriate/${row.id}?screenType=View`}
                                className="budget-reapp-action-btn budget-reapp-action-btn--view"
                            >
                                <AiOutlineEye size={16} />
                            </Link>
                        </span>
                    </Tooltip>
                </div>
            ),
            wrap: true,
            gap: 1,
            center: true,
            width: '110px',
        },
        {
            name: 'Order No',
            selector: (row) => row.order_no,
            wrap: true,
            gap: 1,
        },
        {
            name: 'Order Date',
            selector: (row) => row.order_date
                ? moment(row.order_date, 'YYYY-MM-DD').format('DD-MM-YYYY')
                : '',
            wrap: true,
            gap: 1,
        },
        {
            name: 'Order Amount',
            selector: (row) => formatAmount(row.order_value),
            wrap: true,
            gap: 1,
        },
        {
            name: 'Approval Status',
            cell: (row) => <ApprovalStatusCell row={row} />,
            wrap: true,
            gap: 1,
            center: true,
            minWidth: '160px',
        },
    ];

    const handleChangeRowsPerPage = (currentRowsPerPage, currentPage) => {
        setRowsPerPage(currentRowsPerPage);
        setCurrentPage(1); // Reset to the first page when rows per page changes
    };

    const fetchChallans = async () => {
        try {
            const resp = await get_budget_reappropriate({
                from_date: '',
                to_date: '',
                department_id: filterApplied?.department_id || authData?.user?.department_details?.id,
                financial_year: fyId,
                pending,
            });
            if (resp.data.status) {
                setData(resp.data.result);
            }
        } catch (error) {
            setData([]);
        }
    }
    useEffect(() => {
        fetchChallans();
    }, [filterApplied.department_id, fyId, pending])
    return (
        <div>
             <Card>
                <CardContent>
                    <DataTable
                        customStyles={customStyles}
                        className="dataTables_wrapper"
                        columns={columns}
                        data={data}
                        fixedHeader
                        fixedHeaderScrollHeight="600px"
                        pagination
                        paginationPerPage={rowsPerPage}
                        paginationTotalRows={data.length}
                        paginationRowsPerPageOptions={[10, 25, 50, 100]}
                        onChangeRowsPerPage={handleChangeRowsPerPage}
                    />
                </CardContent>
            </Card>
            
        </div>
    )

}